<template>
    <router-view v-slot="{ Component }">
        <transition name="page-fade" mode="out-in">
            <component :is="Component" />
        </transition>
    </router-view>
</template>

<script setup>
</script>

<style>
.page-fade-enter-active,
.page-fade-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
}
.page-fade-enter-from {
    opacity: 0;
    transform: translateY(6px);
}
.page-fade-leave-to {
    opacity: 0;
    transform: translateY(-4px);
}
</style>
